export type CanvasPoint = { x: number; y: number }

type DrawOptions = {
  ctx: CanvasRenderingContext2D
  points: CanvasPoint[]
  label: string
  color: string
  lineWidth?: number
  fontMinSize?: number
  fontMaxSize?: number
  fontRatio?: number
  labelRadiusRatio?: number
}

const DEFAULT_LINE_WIDTH = 2
const DEFAULT_FONT_MIN = 10
const DEFAULT_FONT_MAX = 20
const DEFAULT_FONT_RATIO = 0.06
const DEFAULT_LABEL_RADIUS_RATIO = 0.55

export function drawMeasurementPath({
  ctx,
  points,
  label,
  color,
  lineWidth = DEFAULT_LINE_WIDTH,
  fontMinSize = DEFAULT_FONT_MIN,
  fontMaxSize = DEFAULT_FONT_MAX,
  fontRatio = DEFAULT_FONT_RATIO,
  labelRadiusRatio = DEFAULT_LABEL_RADIUS_RATIO
}: DrawOptions) {
  if (points.length < 2) return

  ctx.strokeStyle = color
  ctx.lineWidth = lineWidth
  ctx.beginPath()
  ctx.moveTo(points[0].x, points[0].y)
  points.slice(1).forEach(point => ctx.lineTo(point.x, point.y))
  ctx.stroke()

  const first = points[0]
  const second = points[1]
  const midpoint = {
    x: (first.x + second.x) / 2,
    y: (first.y + second.y) / 2
  }
  const segmentLength = Math.hypot(second.x - first.x, second.y - first.y)
  const fontSize = Math.min(fontMaxSize, Math.max(fontMinSize, segmentLength * fontRatio))
  const radius = fontSize * labelRadiusRatio

  ctx.beginPath()
  ctx.fillStyle = '#FFFFFF'
  ctx.arc(midpoint.x, midpoint.y, radius, 0, Math.PI * 2)
  ctx.fill()

  ctx.fillStyle = '#000000'
  ctx.font = `${fontSize}px sans-serif`
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.fillText(label, midpoint.x, midpoint.y)
}